import React from "react";
import { DeviceContext } from "../../../utils/contexts/globalContexts";
import styles from "./HeaderLayout.module.scss";
import { ReactComponent as KsLogo } from "../../../assets/logo/ks-logo.svg";

import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

type Props = {
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
};

const HeaderLayout = ({ leftContent, rightContent }: Props) => {
  const { isMobile } = React.useContext(DeviceContext);
  const navigate = useNavigate();
  const goToMainPage = () =>
    window.location.replace(
      process.env.REACT_APP_KULCSUZLET_BASE_URL as string
    );

  return (
    <div className={styles["table-row"]}>
      <Grid
        container
        spacing={0}
        m={"10px"}
        className={styles.header}
        justifyContent={"space-between"}
      >
        <Grid item xs={false}>
          <KsLogo
            // onClick={goToMainPage}
            style={{
              // cursor: "pointer",
              height: isMobile ? "31px" : "26px",
              width: isMobile ? "180px" : "126px",
            }}
            className="md:h-[26px] md:w-[126px] h-[31px] w-[180px]"
          />
        </Grid>
        <Grid
          item
          xs={false}
          maxWidth={isMobile ? "auto" : "70vw"}
          maxHeight={"90px"}
          width={isMobile ? "100%" : "auto"}
        >
          {rightContent}
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderLayout;
